export const LoadingPage = () => <div />;
